import { useState, useEffect } from 'react';

export default function HomePage() {
  const [currentSection, setCurrentSection] = useState(0);
  const [showDeliveryModal, setShowDeliveryModal] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const heroImages = [
    {
      url: 'https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/dd60aef940632ae7be53026e5b0b87cd.jpeg',
      position: 'left 60%'
    },
    {
      url: 'https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/04968f2fc16de1cf421e886457caec15.jpeg',
      position: 'center'
    },
    {
      url: 'https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/f16369a94cc752d078849faeb46940cd.jpeg',
      position: 'center'
    },
    {
      url: 'https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/169609b7fe851a4de0c605d756ac2fc5.jpeg',
      position: 'center'
    }
  ];
  
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('.full-section');
      const scrollPosition = window.scrollY + window.innerHeight / 2;
      
      sections.forEach((section, index) => {
        const sectionTop = (section as HTMLElement).offsetTop;
        const sectionHeight = (section as HTMLElement).offsetHeight;
        
        if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
          setCurrentSection(index);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    
    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (index: number) => {
    const sections = document.querySelectorAll('.full-section');
    sections[index]?.scrollIntoView({ behavior: 'smooth' });
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroImages.length) % heroImages.length);
  };

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Restaurant",
    "name": "Tatsu Ramen Gyoza Bar",
    "image": [
      "https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/dd60aef940632ae7be53026e5b0b87cd.jpeg",
      "https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/5dc7971329ab2ced1186e8b08ed7a9c6.jpeg",
      "https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/86264f5e348e08b38d57850d2d9a8aed.jpeg"
    ],
    "@id": siteUrl,
    "url": siteUrl,
    "telephone": "+61738541387",
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "12 Duncan St",
      "addressLocality": "Fortitude Valley",
      "addressRegion": "QLD",
      "postalCode": "4006",
      "addressCountry": "AU"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": -27.456959,
      "longitude": 153.034778
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday"],
        "opens": "11:00",
        "closes": "14:30"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday"],
        "opens": "17:00",
        "closes": "21:30"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Friday",
        "opens": "11:00",
        "closes": "14:30"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Friday",
        "opens": "17:00",
        "closes": "22:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "11:30",
        "closes": "14:30"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "17:00",
        "closes": "22:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Sunday",
        "opens": "11:30",
        "closes": "14:30"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Sunday",
        "opens": "17:00",
        "closes": "21:30"
      }
    ],
    "servesCuisine": "Japanese",
    "menu": `${siteUrl}#menu`,
    "acceptsReservations": "True",
    "paymentAccepted": "Card, Digital Payments"
  };

  const menuJsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Tatsu Ramen Gyoza Bar Menu",
    "description": "本格的な日本料理メニュー - ラーメン、餃子、刺身、寿司、カレー、カクテル",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "item": {
          "@type": "MenuItem",
          "name": "Tonkotsu Ramen",
          "description": "Pork and chicken stock soup, pork char siu, thinly sliced shallot, seaweed, boiled egg",
          "image": "https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/30778417a0ef16c01a8c7b692b4d3cf1.jpeg"
        }
      },
      {
        "@type": "ListItem",
        "position": 2,
        "item": {
          "@type": "MenuItem",
          "name": "Pan Fried Pork Gyoza",
          "description": "Pan-fried pork dumplings",
          "image": "https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/45993253a01699bb0b9c33e7f1873cf2.jpeg"
        }
      },
      {
        "@type": "ListItem",
        "position": 3,
        "item": {
          "@type": "MenuItem",
          "name": "Chicken Katsu Curry",
          "description": "Japanese curry served with rice and red pickles",
          "image": "https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/6423c6a3fedc9b68ba43451362acf257.jpeg"
        }
      },
      {
        "@type": "ListItem",
        "position": 4,
        "item": {
          "@type": "MenuItem",
          "name": "Mixed Sashimi",
          "description": "Pieces of tuna and salmon sashimi",
          "image": "https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/315e4bba7b99a0592955bdc909ed930e.jpeg"
        }
      }
    ]
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(menuJsonLd) }} />
      
      <div className="font-serif bg-zinc-900">
        {/* Navigation */}
        <nav className="fixed top-0 left-0 right-0 z-50 bg-zinc-900/95 backdrop-blur-sm border-b border-zinc-800">
          <div className="flex items-center justify-between px-8 py-4">
            <div className="flex items-center space-x-2">
              <h1 className="text-xl font-bold text-amber-100">Tatsu Ramen Gyoza Bar</h1>
            </div>
            <div className="flex space-x-8">
              <button 
                onClick={() => scrollToSection(0)}
                className="text-amber-100/80 hover:text-amber-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection(2)}
                className="text-amber-100/80 hover:text-amber-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Menu
              </button>
              <button 
                onClick={() => scrollToSection(3)}
                className="text-amber-100/80 hover:text-amber-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Restaurant Info
              </button>
            </div>
          </div>
        </nav>

        {/* Hero Section with Carousel */}
        <section className="full-section relative h-screen flex items-center justify-center overflow-hidden">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
              style={{
                backgroundImage: `url(${image.url})`,
                backgroundPosition: image.position
              }}
            />
          ))}
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40" />
          
          {/* Carousel Controls */}
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 bg-black/50 hover:bg-black/70 rounded-full flex items-center justify-center text-white transition-colors cursor-pointer"
            aria-label="Previous slide"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>
          
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 bg-black/50 hover:bg-black/70 rounded-full flex items-center justify-center text-white transition-colors cursor-pointer"
            aria-label="Next slide"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>
          
          {/* Carousel Indicators */}
          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex space-x-2">
            {heroImages.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === currentSlide 
                    ? 'bg-amber-100 w-8' 
                    : 'bg-white/50 hover:bg-white/80'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
          
          <div className="relative z-10 text-center text-white">
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-light tracking-wide text-amber-100">TATSU</h2>
            </div>
            <p className="text-xl md:text-2xl font-light text-amber-50">Ramen & Gyoza Bar</p>
            <p className="text-lg mt-4 opacity-90 text-amber-50">Authentic Japanese Cuisine Brisbane</p>
          </div>
        </section>

        {/* About Section */}
        <section className="full-section min-h-screen bg-zinc-800 py-16 flex items-center">
          <div className="max-w-6xl mx-auto px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-light text-amber-100 mb-6">About Tatsu</h2>
              <div className="w-24 h-px bg-amber-600 mx-auto mb-8"></div>
            </div>
            
            <div className="mb-8 grid md:grid-cols-2 gap-6">
              <div className="w-full h-80 overflow-hidden rounded-lg shadow-lg">
                <img 
                  src="https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/e344dd728bbe62a625ed44886557bff1.jpeg"
                  alt="Tatsu Restaurant Interior"
                  className="w-full h-full object-cover brightness-110"
                />
              </div>
              <div className="w-full h-80 overflow-hidden rounded-lg shadow-lg">
                <img 
                  src="https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/33efa17b290ac075793707acc9b479f3.jpeg"
                  alt="Tatsu Restaurant Atmosphere"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-full h-80 overflow-hidden rounded-lg shadow-lg">
                <img 
                  src="https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/09db1a24505d882d6ba8e4c76b8a113a.jpeg"
                  alt="Tatsu Restaurant Dining"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-full h-80 overflow-hidden rounded-lg shadow-lg">
                <img 
                  src="https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/99b6327e9184823d03cc14bc2d02fd76.jpeg"
                  alt="Tatsu Restaurant Experience"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            
            <div className="space-y-6 text-center">
              <p className="text-lg text-amber-50/90 leading-relaxed">
                Ramen, gyoza, sashimi & more — plus cocktails, sake, vegan options and spicy dishes.
              </p>
              <p className="text-lg text-amber-50/90 leading-relaxed">
                Open late, 7 days a week with warm Japanese hospitality.
              </p>
            </div>
          </div>
        </section>

        {/* Menu Section */}
        <section className="full-section relative min-h-screen py-20 bg-zinc-900">
          <div 
            className="absolute inset-0 bg-cover bg-center opacity-40"
            style={{
              backgroundImage: 'url(https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/be476d5ad50b54f2e01536f3214c0337.jpeg)',
              backgroundPosition: 'center 60%'
            }}
          />
          <div className="relative z-10 max-w-6xl mx-auto px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-light text-amber-100 mb-8">Menu Selection</h2>
              <p className="text-lg text-amber-50/80 mb-4">A taste of what we offer</p>
              <div className="w-24 h-px bg-amber-600 mx-auto mb-12"></div>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
              <div className="bg-zinc-800 rounded-lg shadow-lg p-6 text-center border border-zinc-700 hover:border-amber-600/50 transition-colors">
                <img 
                  src="https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/30778417a0ef16c01a8c7b692b4d3cf1.jpeg"
                  alt="Tonkotsu Ramen"
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
                <h3 className="text-xl font-medium mb-2 text-amber-100">Tonkotsu Ramen</h3>
                <p className="text-amber-50/70 text-sm">Pork and chicken stock soup, pork char siu, thinly sliced shallot, seaweed, boiled egg</p>
              </div>
              
              <div className="bg-zinc-800 rounded-lg shadow-lg p-6 text-center border border-zinc-700 hover:border-amber-600/50 transition-colors">
                <img 
                  src="https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/45993253a01699bb0b9c33e7f1873cf2.jpeg"
                  alt="Gyoza"
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
                <h3 className="text-xl font-medium mb-2 text-amber-100">Pan Fried Pork Gyoza</h3>
                <p className="text-amber-50/70 text-sm">Pan-fried pork dumplings</p>
              </div>

              <div className="bg-zinc-800 rounded-lg shadow-lg p-6 text-center border border-zinc-700 hover:border-amber-600/50 transition-colors">
                <div className="w-full h-48 overflow-hidden rounded-lg mb-4">
                  <img 
                    src="https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/6423c6a3fedc9b68ba43451362acf257.jpeg"
                    alt="Chicken Katsu Curry"
                    className="w-full h-full object-cover scale-150"
                    style={{ objectPosition: 'center 30%' }}
                  />
                </div>
                <h3 className="text-xl font-medium mb-2 text-amber-100">Chicken Katsu Curry</h3>
                <p className="text-amber-50/70 text-sm">Japanese curry served with rice and red pickles</p>
              </div>

              <div className="bg-zinc-800 rounded-lg shadow-lg p-6 text-center border border-zinc-700 hover:border-amber-600/50 transition-colors">
                <div className="w-full h-48 overflow-hidden rounded-lg mb-4">
                  <img 
                    src="https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/0aab15b8cbd938fc1c2373960d6ab77c.png"
                    alt="Sashimi Platter"
                    className="w-full h-full object-cover scale-125"
                    style={{ objectPosition: 'center 60%' }}
                  />
                </div>
                <h3 className="text-xl font-medium mb-2 text-amber-100">Mixed Sashimi</h3>
                <p className="text-amber-50/70 text-sm">Pieces of tuna and salmon sashimi</p>
              </div>

              <div className="bg-zinc-800 rounded-lg shadow-lg p-6 text-center border border-zinc-700 hover:border-amber-600/50 transition-colors">
                <img 
                  src="https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/c8c5f3823b0923c1a659c60f0b7b75bc.jpeg"
                  alt="Sushi"
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
                <h3 className="text-xl font-medium mb-2 text-amber-100">Sushi</h3>
                <p className="text-amber-50/70 text-sm">Japanese food with rice and raw fish</p>
              </div>

              <div className="bg-zinc-800 rounded-lg shadow-lg p-6 text-center border border-zinc-700 hover:border-amber-600/50 transition-colors">
                <img 
                  src="https://static.readdy.ai/image/c4ebca1b92e2c1129f4e15d5fe484a6a/c5e32c21d10eb4b5177e4ae351f2ae34.jpeg"
                  alt="Premium Sake"
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
                <h3 className="text-xl font-medium mb-2 text-amber-100">Passionfruit Colada</h3>
                <p className="text-amber-50/70 text-sm">White rum, coconut cream, pineapple juice and passionfruit puree</p>
              </div>
            </div>

            <div className="text-center">
              <p className="text-base text-amber-50/70 mb-2">...and much more!</p>
              <p className="text-lg mb-8 text-amber-100">Order Online for Pickup & Delivery</p>
              <button 
                onClick={() => setShowDeliveryModal(true)}
                className="inline-block bg-amber-600 text-white px-8 py-3 rounded-lg hover:bg-amber-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
              >
                Order Now
              </button>
            </div>
          </div>
        </section>

        {/* Restaurant Info Section */}
        <section className="full-section min-h-screen bg-zinc-800 py-20">
          <div className="max-w-4xl mx-auto px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-light text-amber-100 mb-8">Restaurant Info</h2>
              <div className="w-24 h-px bg-amber-600 mx-auto mb-12"></div>
            </div>

            <div className="space-y-12">
              <div className="text-center">
                <p className="text-lg font-medium mb-4 text-amber-100">◎ Dine-in & Take-away Available</p>
                <div className="w-full h-px bg-zinc-700 my-8"></div>
                
                <p className="text-lg font-medium mb-2 text-amber-100">◎ Payment Options</p>
                <p className="text-base mb-6 text-amber-50/90">Card, Digital Payments</p>
                <div className="flex justify-center space-x-4 mb-8">
                  <i className="ri-bank-card-line text-3xl text-amber-100/80"></i>
                  <i className="ri-smartphone-line text-3xl text-amber-100/80"></i>
                </div>
                <div className="w-full h-px bg-zinc-700 my-8"></div>

                <div className="mb-8">
                  <p className="text-lg font-medium mb-4 text-amber-100">◎ Operating Hours</p>
                  <div className="space-y-2 text-amber-50/90">
                    <p className="font-medium mb-3">Open 7 Days a Week</p>
                    <div className="space-y-1">
                      <p><strong>Monday-Thursday:</strong></p>
                      <p>Lunch: 11:00-14:30 | Dinner: 17:00-21:30</p>
                      <p><strong>Friday:</strong></p>
                      <p>Lunch: 11:00-14:30 | Dinner: 17:00-22:00</p>
                      <p><strong>Saturday:</strong></p>
                      <p>Lunch: 11:30-14:30 | Dinner: 17:00-22:00</p>
                      <p><strong>Sunday:</strong></p>
                      <p>Lunch: 11:30-14:30 | Dinner: 17:00-21:30</p>
                    </div>
                  </div>
                </div>
                <div className="w-full h-px bg-zinc-700 my-8"></div>

                <div className="mb-8">
                  <p className="text-lg font-medium mb-4 text-amber-100">◎ Location</p>
                  <p className="text-amber-50/90">12 Duncan St, Fortitude Valley QLD 4006</p>
                  <p className="text-amber-50/80 mt-2">
                    Phone: <a href="tel:+61738541387" className="hover:text-amber-600 transition-colors cursor-pointer underline">07-3854-1387</a>
                  </p>
                </div>

                <div className="bg-zinc-900 rounded-lg shadow-lg overflow-hidden border border-zinc-700">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3540.234567!2d153.034778!3d-27.456959!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b915a1d0e0e0e0e%3A0x0!2s12%20Duncan%20St%2C%20Fortitude%20Valley%20QLD%204006!5e0!3m2!1sen!2sau!4v1620000000000!5m2!1sen!2sau"
                    width="100%" 
                    height="400"
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="w-full"
                    title="Tatsu Ramen Gyoza Bar Location"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Delivery Modal */}
        {showDeliveryModal && (
          <div 
            className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4"
            onClick={() => setShowDeliveryModal(false)}
          >
            <div 
              className="bg-zinc-800 rounded-lg max-w-2xl w-full p-8 relative border border-zinc-700"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setShowDeliveryModal(false)}
                className="absolute top-4 right-4 text-amber-100 hover:text-amber-600 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
              
              <h3 className="text-2xl font-light text-amber-100 mb-6 text-center">Choose Your Order Method</h3>
              
              <div className="grid md:grid-cols-3 gap-6">
                <a
                  href="https://tatsu-ramen-gyoza-bar.square.site/s/order?item=AMYIPHYEQH6CRWOHXBLKHSEN"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-zinc-900 rounded-lg p-6 text-center hover:border-amber-600 transition-colors border border-zinc-700 cursor-pointer group"
                >
                  <div className="w-16 h-16 bg-amber-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-amber-700 transition-colors">
                    <i className="ri-shopping-bag-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-lg font-medium text-amber-100 mb-2">Square Online</h4>
                  <p className="text-sm text-amber-50/70">Pickup Order</p>
                </a>

                <a
                  href="https://www.ubereats.com/au/store/tatsu-ramen-and-gyoza-bar/R0FkHQuOQlSM8-p7oxnQug?diningMode=DELIVERY&mod=merchantUnavailable&modctx=%257B%2522storeUuid%2522%253A%25224741641d-0b8e-4254-8cf3-ea7ba319d0ba%2522%257D&ps=1&surfaceName="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-zinc-900 rounded-lg p-6 text-center hover:border-amber-600 transition-colors border border-zinc-700 cursor-pointer group"
                >
                  <div className="w-16 h-16 bg-amber-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-amber-700 transition-colors">
                    <i className="ri-e-bike-2-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-lg font-medium text-amber-100 mb-2">Uber Eats</h4>
                  <p className="text-sm text-amber-50/70">Delivery Order</p>
                </a>

                <a
                  href="https://www.doordash.com/store/tatsu-ramen-&-gyoza-bar-fortitude-valley-1068614/21227546/?cursor=eyJzZWFyY2hfaXRlbV9jYXJvdXNlbF9jdXJzb3IiOnsicXVlcnkiOiJUYXRzdSByYW1lbiIsIml0ZW1faWRzIjpbXSwic2VhcmNoX3Rlcm0iOiJ0YXRzdSByYW1lbiIsInZlcnRpY2FsX2lkIjotOTk5LCJ2ZXJ0aWNhbF9uYW1lIjoiYWxsIiwicXVlcnlfaW50ZW50IjoiU1RPUkVfUlgifSwic3RvcmVfcHJpbWFyeV92ZXJ0aWNhbF9pZHMiOlsxLDQsMTAwMzMzXX0=&pickup=false"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-zinc-900 rounded-lg p-6 text-center hover:border-amber-600 transition-colors border border-zinc-700 cursor-pointer group"
                >
                  <div className="w-16 h-16 bg-amber-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-amber-700 transition-colors">
                    <i className="ri-truck-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-lg font-medium text-amber-100 mb-2">DoorDash</h4>
                  <p className="text-sm text-amber-50/70">Delivery Order</p>
                </a>
              </div>
            </div>
          </div>
        )}

        {/* Footer */}
        <footer className="bg-zinc-900 py-16 border-t border-zinc-800">
          <div className="max-w-6xl mx-auto px-8">
            <div className="grid md:grid-cols-3 gap-12 text-center">
              <div>
                <h3 className="text-2xl font-bold text-amber-100 mb-4">TATSU</h3>
                <p className="text-amber-50/80 mb-4">Ramen & Gyoza Bar</p>
                <p className="text-sm text-amber-50/60">Authentic Japanese Cuisine</p>
              </div>
              
              <div>
                <h3 className="font-medium mb-4 text-amber-100">Operating Hours</h3>
                <div className="space-y-1 text-amber-50/80 text-sm">
                  <p className="font-medium mb-2">Open 7 Days</p>
                  <p><strong>Mon-Thu:</strong> 11:00-14:30, 17:00-21:30</p>
                  <p><strong>Fri-Sat:</strong> 11:00/11:30-14:30, 17:00-22:00</p>
                  <p><strong>Sun:</strong> 11:30-14:30, 17:00-21:30</p>
                </div>
                <div className="mt-6">
                  <p className="text-sm text-amber-50/80">12 Duncan St, Fortitude Valley</p>
                  <p className="text-sm text-amber-50/80">
                    Phone: <a href="tel:+61738541387" className="hover:text-amber-600 transition-colors cursor-pointer underline">07-3854-1387</a>
                  </p>
                </div>
              </div>

              <div>
                <h3 className="font-medium mb-4 text-amber-100">Follow Us</h3>
                <div className="flex justify-center space-x-4 mb-6">
                  <a 
                    href="https://www.instagram.com/tatsubrisbane/?hl=en" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-zinc-800 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors border border-zinc-700"
                  >
                    <i className="ri-instagram-line text-amber-100"></i>
                  </a>
                  <a 
                    href="https://www.google.com/maps/place/Tatsu+Ramen+Gyoza+Bar/@-27.4581381,153.0307176,17z/data=!4m8!3m7!1s0x6b9159f3c1b27069:0x3fb892b8f2e942a!8m2!3d-27.4581381!4d153.0332925!9m1!1b1!16s%2Fg%2F11c2nvldft?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D#:~:text=Menu-,Reviews,-About" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-zinc-800 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors border border-zinc-700"
                  >
                    <i className="ri-star-fill text-amber-100"></i>
                  </a>
                </div>
              </div>
            </div>
            
            <div className="border-t border-zinc-800 pt-8 mt-12 text-center text-amber-50/70">
              <p>© 2024 Tatsu Ramen and Gyoza Bar. All Rights Reserved.</p>
              <p className="mt-2 text-sm">
                <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-amber-100 transition-colors">Powered by Readdy</a>
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
